// IANA time zones for the account time zone setting (tenants.time_zone), labelled with their
// current UTC offset. The database refuses a name Postgres does not know, so this list only has
// to be a good menu, not the authority.

const FALLBACK = [
  'UTC',
  'America/Los_Angeles',
  'America/Denver',
  'America/Phoenix',
  'America/Chicago',
  'America/New_York',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Edmonton',
  'America/Vancouver',
  'America/Toronto',
];

/** Every zone the browser knows, or a short North American list when it cannot say. */
export function timeZoneNames(): string[] {
  const intl = Intl as unknown as { supportedValuesOf?: (key: 'timeZone') => string[] };
  let names: string[] = [];
  try {
    names = intl.supportedValuesOf?.('timeZone') ?? [];
  } catch {
    names = [];
  }
  if (names.length === 0) names = FALLBACK;
  // Some browsers leave UTC out of supportedValuesOf; it is the default, so it must be offered.
  return names.includes('UTC') ? names : ['UTC', ...names];
}

/** "UTC-07:00" for a zone at a moment; "UTC" for a zero offset. */
export function utcOffsetLabel(timeZone: string, at: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'longOffset' }).formatToParts(at);
  const name = parts.find((p) => p.type === 'timeZoneName')?.value ?? 'GMT';
  // A zero offset prints as "GMT" or "GMT+00:00" depending on the engine.
  return /^GMT(\+00:00)?$/.test(name) ? 'UTC' : name.replace('GMT', 'UTC');
}

export function timeZoneOptions(at: Date = new Date()): { label: string; value: string }[] {
  return timeZoneNames().map((name) => ({
    value: name,
    label: name === 'UTC' ? 'UTC' : `${name.replace(/_/g, ' ')} (${utcOffsetLabel(name, at)})`,
  }));
}
